import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Skeleton } from '@hbf/dsl';

import { PreviewCardWidth } from '../constants';

const useStyles = makeStyles()(() => ({
  textBlock: {
    padding: '12px',
  },
}));

const ListingCardSkeleton: React.FC = () => {
  const { classes } = useStyles();

  return (
    <div>
      <Skeleton variant="rectangular" height={(PreviewCardWidth * 2) / 3} />
      <div className={classes.textBlock}>
        <Skeleton variant="text" height={32} />
        <Skeleton variant="text" height={16} />
        <Skeleton variant="text" height={16} />
      </div>
    </div>
  );
};

export { ListingCardSkeleton };
